import React from 'react';

export const TEAM_CODES = {
  Algeria: 'dz', Argentina: 'ar', Australia: 'au', Austria: 'at',
  Belgium: 'be', Bosnia: 'ba', Brazil: 'br',
  Canada: 'ca', 'Cape Verde': 'cv', Colombia: 'co', Croatia: 'hr',
  Curacao: 'cw', 'Czech Republic': 'cz',
  'DR Congo': 'cd',
  Ecuador: 'ec', Egypt: 'eg', England: 'gb-eng',
  France: 'fr',
  Germany: 'de', Ghana: 'gh',
  Haiti: 'ht',
  Iran: 'ir', Iraq: 'iq', 'Ivory Coast': 'ci',
  Japan: 'jp', Jordan: 'jo',
  Mexico: 'mx', Morocco: 'ma',
  Netherlands: 'nl', 'New Zealand': 'nz', Norway: 'no',
  Panama: 'pa', Paraguay: 'py', Portugal: 'pt',
  Qatar: 'qa',
  'Saudi Arabia': 'sa', Scotland: 'gb-sct', Senegal: 'sn',
  'South Africa': 'za', 'South Korea': 'kr', Spain: 'es', Sweden: 'se', Switzerland: 'ch',
  Tunisia: 'tn', Turkey: 'tr',
  Uruguay: 'uy', USA: 'us', Uzbekistan: 'uz',
};

export function teamCode(team) {
  return TEAM_CODES[team] || null;
}

export function Flag({ team, size = 'md', className = '' }) {
  const code = teamCode(team);
  const cls = `flag-chip${size === 'lg' ? ' flag-chip--lg' : size === 'sm' ? ' flag-chip--sm' : ''}${className ? ' ' + className : ''}`;
  if (!code) return <span className={cls} aria-hidden="true" style={{ background: 'var(--ink-700)' }} />;
  return <span className={`${cls} fi fi-${code}`} role="img" aria-label={team} title={team} />;
}
